import { useEffect, useState } from "react";

import {
  generatePath,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";

import { getAnchor } from "@/api/endpoints/mentions";
import { FILTER } from "@/constants";
import PublicLayout from "@/containers/PublicLayout";
import { ROUTES } from "@/routes_new";
import { pageFromFeedIndex } from "@/utils";
import deleteNil from "@/utils/deleteNil";
import { stringifyQuery } from "@/utils/query-string";
import { useQuery } from "@tanstack/react-query";

const AnchorRedirect = () => {
  const { orgUuid, search_uuid, mention_uuid } = useParams<{
    orgUuid: string;
    search_uuid: string;
    mention_uuid: string;
  }>();
  const [redirectTo, setRedirectTo] = useState<string>();
  const { pathname } = useLocation();

  const { data } = useQuery({
    queryKey: ["anchor", mention_uuid],
    queryFn: () => getAnchor(mention_uuid),
  });

  useEffect(() => {
    if (!data?.ok) return;
    if (data.status === 205) {
      const newOrgUuid = data.headers.get("x-new-organization-uuid");
      setRedirectTo(pathname.replace("/a/", `/a/${newOrgUuid}/`));
      return;
    }
    const response = data.data;

    if (response.feed_index === undefined) {
      throw new Error();
    }

    // generate the URL. pass the mention_uuid along as a hash
    const path = generatePath(ROUTES.MENTION_DETAIL_ORGID, {
      orgUuid,
      uuid: search_uuid,
    });
    const url = `${path}?${stringifyQuery(
      deleteNil({
        [FILTER.PAGE]: pageFromFeedIndex(response.feed_index),
      })
    )}#${mention_uuid}`;

    setRedirectTo(url);
  }, [
    data?.data,
    data?.headers,
    data?.ok,
    data?.status,
    mention_uuid,
    orgUuid,
    pathname,
    search_uuid,
  ]);

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  return (
    <PublicLayout>
      <div className="flex justify-center pt-5 mt-5">
        <div className="spinner-grow" />
      </div>
    </PublicLayout>
  );
};

export default AnchorRedirect;
